import { useState } from "react";
import { usePrecisionGameStore } from "../store/precisionGame.store";
import { PrecisionGameLeaderboard } from "../models/precisionGame.types";
import { useCurrentUserProfile } from "@/store/auth/userProfile.store";
import { timestamp } from "@/api/firebase/firebase.config";

export const usePrecisionGameState = (collection: string) => {
  const currentUser = useCurrentUserProfile((s) => s.user);
  const { attemptCounts, hasWonCollection } = usePrecisionGameStore();

  const attemptCount = attemptCounts[collection] || 0;
  const hasWon = hasWonCollection(collection);

  // Game state
  const [success, setSuccess] = useState<boolean>(hasWon);
  const [currentTime, setCurrentTime] = useState<number>(0);
  const [firstClickTime, setFirstClickTime] = useState<number | null>(null);

  // Leaderboard entry values
  const [values] = useState<PrecisionGameLeaderboard>({
    attempts: attemptCount,
    score: currentTime,
    uid: currentUser.uid,
    userName: currentUser.userName,
    created_at: timestamp.now(),
  });

  return {
    currentUser,
    attemptCount,
    hasWon,
    success,
    setSuccess,
    currentTime,
    setCurrentTime,
    firstClickTime,
    setFirstClickTime,
    values,
  };
};
